import(/* webpackMode: "eager" */ "/app/src/ui/app/global-error.tsx");
